import ConversationEffect from "src/Animations/ConversationEffect";
import setCurrentPage from "src/Utils/setCurrentPage";

export const DATA_GEN_AI_DEMO_IEAM_4 = {
  title: `AI takes center stage, providing a selection\n of solutions that match Tony's needs with\n unparalleled precision.`,
  subtitle: "ai ASSISTED demo",
  next: {
    label: "CONTINUE",
    onClick: () => setCurrentPage("ENG_120"),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage("ENG_118"),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "ENG/IEAM/IEAM_GEN_AI_Demo_01.png",
  rightSideComponent: (
    <ConversationEffect
      images={[
        {
          image: "ENG/IEAM/IEAM_GEN_AI_DEMO_04_BUBBLE.png",
          imageStyle: { alignSelf: "flex-end", marginRight: "-25px" },
        },
        {
          image: "ENG/IEAM/IEAM_GEN_AI_DEMO_04_TILE_1.png",
          imageStyle: {
            alignSelf: "flex-end",
            marginTop: "-8px",
            marginRight: "15px",
          },
        },
        {
          image: "ENG/IEAM/IEAM_GEN_AI_DEMO_04_TILE_2.png",
          imageStyle: { marginTop: "-326px" },
        },
      ]}
      pageNumber={"ENG_119"}
    />
  ),
};
